import moment, {Moment} from 'moment'
import {Nullable} from '../../../app/TypeHelpers'

export class AssocDirectorPositionInfo {
    assocDirectorPositionId: number
    positionRoleId: string
    midtermAppointmentDate: Nullable<Moment>
    midtermTerminationDate: Nullable<Moment>
    directorPositionTermStartDate: Nullable<Moment>
    directorPositionTermEndDate: Nullable<Moment>
    version: number

    constructor(
        assocDirectorPositionId: number,
        positionRoleId: string,
        midtermAppointmentDate: Nullable<Moment>,
        midtermTerminationDate: Nullable<Moment>,
        directorPositionTermStartDate: Nullable<Moment>,
        directorPositionTermEndDate: Nullable<Moment>,
        version: number,
    ) {
        this.assocDirectorPositionId = assocDirectorPositionId
        this.positionRoleId = positionRoleId
        this.midtermAppointmentDate = midtermAppointmentDate
        this.midtermTerminationDate = midtermTerminationDate
        this.directorPositionTermStartDate = directorPositionTermStartDate
        this.directorPositionTermEndDate = directorPositionTermEndDate
        this.version = version
    }

    static from(json: any): AssocDirectorPositionInfo {
        return new AssocDirectorPositionInfo(
            json.assocDirectorPositionId,
            json.positionRoleId,
            json.midtermAppointmentDate ? moment(json.midtermAppointmentDate) : null,
            json.midtermTerminationDate ? moment(json.midtermTerminationDate) : null,
            json.directorPositionTermStartDate ? moment(json.directorPositionTermStartDate): null,
            json.directorPositionTermEndDate ? moment(json.directorPositionTermEndDate): null,
            json.version,
        )
    }
}
